var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`${_vm.titleDisplayClass} text-center font-weight-light mb-8 mt-12`},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }